import { Grid } from '@material-ui/core';
import FaqItem from 'containers/SiteMapPage/FaqItem';
import messages from 'containers/SiteMapPage/messages';
import React from 'react';
import { useSelector } from 'react-redux';
import { hasUniversSelector } from 'store/user/selectors';
import { PRIVILEGES } from 'utils/globalConst';
import data from 'containers/SiteMapPage/data';
import { StyledContainer } from 'containers/SiteMapPage/styles';

const univers = [
  {
    name: PRIVILEGES.AUTO,
    title: messages.auto_title,
  },
  {
    name: PRIVILEGES.MRH,
    title: messages.habitation_title,
  },
  {
    name: PRIVILEGES.EPARGN,
    title: messages.saving_title,
  },
];

const Body = () => {
  const hasUnivers = useSelector(hasUniversSelector);

  return (
    <StyledContainer>
      <Grid container spacing={2}>
        {univers.map((item: any) => {
          /* istanbul ignore next */
          return (
            hasUnivers(item.name) && (
              <FaqItem
                key={item.title}
                title={item.title}
                data={data.filter((e: any) => e.univers === item.name)}
              />
            )
          );
        })}
        <FaqItem
          title={messages.others_title}
          data={data.filter((e: any) => e.public)}
        />
      </Grid>
    </StyledContainer>
  );
};
export default Body;
